import { render, staticRenderFns } from "./PosterDesign.vue?vue&type=template&id=18c00a66&"
import script from "./PosterDesign.vue?vue&type=script&lang=js&"
export * from "./PosterDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports